import styles from "./SelectList.module.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import React from "react";

import {ReactComponent as CheckboxIcon} from "../../../assets/svg/check_box_16w.svg";
import {ReactComponent as CheckboxBlankIcon} from "../../../assets/svg/check_box_outline_blank_16w.svg";


const SelectList = ({entries, selectedCount, clickHandler, showSelectAll, isSelectedAll}) => {
  const allSelected = isSelectedAll || (selectedCount === entries.length && entries.length > 0)

  return (
    <div className={styles.PersonVisibleTagsSelectListContainer}>
      <PerfectScrollbar>
        <div className={styles.PersonVisibleTagsSelectListTable}>
          {entries.map(item => (
            <button
              key={item.id}
              onClick={() => clickHandler(item.id)}
            >
              {item.selected
                ? <CheckboxIcon className={styles.PersonVisibleTagsSelectCheckboxItem}/>
                : <CheckboxBlankIcon className={styles.PersonVisibleTagsSelectCheckboxItem} style={{color: '#b9b9b9'}}/>
              }
              <span>{item.name}</span>
            </button>
          ))}
        </div>
      </PerfectScrollbar>
      {showSelectAll && <div className={styles.PersonVisibleTagsSelectListButton}>
        <button>
          <span>{allSelected ? 'Deselect All' : 'Select All'}</span>
        </button>
      </div>}
    </div>
  )
}

export default SelectList;
